/**
 * Regras puras de "este valor de ficha está preenchido?".
 *
 * Saíram do `attendanceHelper.js` (que segue reexportando) porque ele importa
 * o Vue e o store: quem só precisa destas regras — o `documentHelper`, e por
 * ele o `useFinishAttendance` do app mobile — puxava o shell Vue inteiro.
 * Este arquivo NÃO pode importar nada do Vue nem do store.
 */
export const isValidMedicalRecordValue = medicalRecordValue => {
  if (!medicalRecordValue) return false

  if (typeof medicalRecordValue === 'string') {
    if (valueIsBiometriaTitle(medicalRecordValue)) return false
    return medicalRecordValue.trim() !== ''
  }

  if (Array.isArray(medicalRecordValue)) {
    return medicalRecordValue.some(isValidMedicalRecordValue)
  }

  if (typeof medicalRecordValue === 'object') {
    return Object.values(medicalRecordValue).some(isValidMedicalRecordValue)
  }

  return true
}

const valueIsBiometriaTitle = medicalRecordValue => {
  return [
    'AL',
    'ACD',
    'TORICA ASD',
    'PANOPTIX',
    'TECNIS MF',
    'VIVITY',
    'SN60WF',
    'SENSAR ONE'
  ].includes(medicalRecordValue)
}

export const hasVisibleHtmlText = html => {
  if (typeof html !== 'string') return isValidMedicalRecordValue(html)
  const text = html
    .replace(/<[^>]*>/g, '')
    .replace(/&(nbsp|#160|#x0*a0|#8203|#x0*200b);/gi, '')
    .replace(/[\s\u00a0\u200b]+/g, '')
  return text !== ''
}
